import { Patient } from '@type';
import { getTimestamp } from '@utils';

import { initialState, STORE_NAME } from './patient-store.constant';
import {
  GetType,
  ResetPatientInfo,
  SessionStarted,
  SetType,
  UpdatePatientInfo,
} from './patient-store.types';

export const updatePatientInfo = (
  set: SetType,
  get: GetType
): UpdatePatientInfo => {
  return (patient: Partial<Patient>) => {
    return set(
      {
        patientInfo: {
          ...get().patientInfo,
          ...patient,
        },
      },
      false,
      `${STORE_NAME}-UPDATE_PATIENT_INFO`
    );
  };
};

export const resetPatientInfo = (set: SetType): ResetPatientInfo => {
  return () => set(initialState, false, `${STORE_NAME}-RESET_PATIENT_INFO`);
};

export const sessionStarted = (set: SetType, get: GetType): SessionStarted => {
  return (sessionId: string) => {
    return updatePatientInfo(
      set,
      get
    )({
      sessionId,
      isSessionExpired: false,
      sessionLastActive: getTimestamp(),
    });
  };
};
